import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { z } from 'zod';

/** @deprecated Use `usePathParams` from `corso-admin-ui` instead. */
export const usePathParams = <T>(schema: z.ZodType<T>) => {
  const params = useParams();
  return useMemo(() => schema.parse(params), [params, schema]);
};
